/* Custom Related Products Section - Add to Cart Functionality */

class CustomRelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setupAddToCartButtons();
  }

  setupAddToCartButtons() {
    const buttons = this.querySelectorAll('.btn');
    
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleAddToCart(button);
      });
    });
  }

  async handleAddToCart(button) {
    const variantId = button.dataset.variantId;
    const quantity = parseInt(button.dataset.quantity) || 1;

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    button.classList.add('btn--loading');
    button.disabled = true;
    const originalText = button.textContent;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      button.classList.remove('btn--loading');
      button.textContent = 'Added!';

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: true }
      }));

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      
      button.classList.remove('btn--loading');
      button.textContent = 'Error!';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }
}

// Register the custom element
if (!customElements.get('custom-related-products')) {
  customElements.define('custom-related-products', CustomRelatedProducts);
}
